import { createDialogProvider } from "src/components/Dialog";
import { CloseTransferWarningDialogContext } from "./context";
import { CloseTransferWarningDialog } from "./CloseTransferWarningDialog";

export const { DialogProvider: CloseTransferWarningDialogProvider } =
  createDialogProvider(
    CloseTransferWarningDialogContext,
    CloseTransferWarningDialog,
    "CloseTransferWarningDialog"
  );
